import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GoogleSigninButtonModule, SocialAuthService } from '@abacritt/angularx-social-login';
import { SupabaseService } from '../../../../../core/supabase.service';
import { NotificationsService } from '../../../../../services/notifications.service';
import { isGoogleSignInHost } from '../../../../../core/auth/google-sign-in-host';

/**
 * « Continuer avec Google », rétabli uniquement pour les domaines web-atrio.com.
 *
 * Le bouton est rendu par le SDK Google ; le jeton reçu est échangé auprès de
 * Supabase (signInWithIdToken), la suite du parcours (session, redirection)
 * étant gérée comme pour les autres connexions par AuthService.
 */
@Component({
  selector: 'app-login-by-social-auth',
  imports: [GoogleSigninButtonModule],
  templateUrl: './login-by-social-auth.component.html',
  styleUrl: './login-by-social-auth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginBySocialAuthComponent {
  private readonly supabase = inject(SupabaseService);
  private readonly notifications = inject(NotificationsService);

  protected readonly showGoogleAuth = isGoogleSignInHost();

  constructor() {
    if (!this.showGoogleAuth) return;
    inject(SocialAuthService).authState
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(user => {
        if (!user?.idToken) return;
        this.supabase.client.auth
          .signInWithIdToken({ provider: 'google', token: user.idToken })
          .then(response => {
            if (response.error) {
              this.notifications.showError('Connexion Google impossible : réessayez, ou connectez-vous avec votre email.');
            }
          });
      });
  }
}
